import { render, staticRenderFns } from "./shopMoudle.vue?vue&type=template&id=3c716f7e&scoped=true&"
import script from "./shopMoudle.vue?vue&type=script&lang=js&"
export * from "./shopMoudle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c716f7e",
  null
  
)

export default component.exports